import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react';
import { useState, useEffect } from 'react';
import { FEATURE_FLAGS } from 'src/utils/growthBook/growthBook.constants';

const platform = Capacitor.getPlatform();
const isWeb = platform === 'web';

export default function useAppVersion() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [appVersion, setAppVersion] = useState<string>('');
  const versionInReview = useFeatureValue(
    FEATURE_FLAGS.VERSION_IN_REVIEW,
    null
  );

  const isAppReviewFlagEnabled = useFeatureIsOn(
    FEATURE_FLAGS.VERSION_IN_REVIEW
  );

  const isInReviewEnabled = isAppReviewFlagEnabled && versionInReview;

  const isInReview =
    isInReviewEnabled && isWeb
      ? true
      : appVersion === versionInReview?.[platform];

  useEffect(() => {
    if (!isWeb) {
      setIsLoading(true);
      App.getInfo()
        .then((info) => {
          setAppVersion(`${info.version}-${info.build}`);
        })
        .finally(() => setIsLoading(false));
    } else if (!isInReview) {
      setIsLoading(false);
    }
  }, []);

  return { appVersion, isInReview, isLoading };
}
